import React from 'react';

import LoginMessage from './LoginMessage';
import ReloadButton from './ReloadButton';
import SettingsButton from './SettingsButton';
import UserMappingButton from './UserMappingButton';

import './footer.css';

const Footer = () => (
  <div className="issue-sidebar-footer">
    <div><LoginMessage/></div>
    <div style={{ flexGrow: 1 }}/>
    <div><UserMappingButton/></div>
    <div><SettingsButton/></div>
    <div><ReloadButton/></div>
  </div>
);

export default Footer;
